import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SuggestionsResponseDto } from '@malou-io/package-dto';

import { environment } from '#environments/environment';
import { ApiResult } from '#shared/models/index';

@Injectable({
    providedIn: 'root',
})
export class SuggestionsApiService {
    private readonly _http = inject(HttpClient);
    private readonly _API_BASE_URL = `${environment.APP_MALOU_API_URL}/api/v1/suggestions`;

    getSuggestions$(restaurantId: string): Observable<ApiResult<SuggestionsResponseDto>> {
        return this._http.get<ApiResult<SuggestionsResponseDto>>(`${this._API_BASE_URL}/${restaurantId}`);
    }
}
